<template>
  <div class="bg-amber-50 border border-amber-300 rounded-xl p-5 flex items-start gap-3">
    <Icon icon="solar:danger-triangle-bold" class="w-6 h-6 text-amber-700 flex-shrink-0 mt-0.5" />
    <div class="min-w-0">
      <h3 class="font-semibold text-amber-900 mb-1">
        Environnement {{ modeStore.isTest ? 'de test' : 'de production' }} indisponible
      </h3>
      <p class="text-sm text-amber-800">
        Votre session est bien active, mais cet environnement ne reconnaît pas encore votre compte.
        C'est en général temporaire, le temps que votre accès y soit propagé.
      </p>
      <p class="text-sm text-amber-800 mt-2">
        Vous pouvez continuer sur l'environnement
        <button
          @click="modeStore.toggle()"
          class="font-semibold underline hover:no-underline"
        >
          {{ modeStore.isTest ? 'de production' : 'de test' }}
        </button>
        en attendant, ou contacter le support Youdégo si cela persiste.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { useModeStore } from '../store/mode'

const modeStore = useModeStore()
</script>
